export default __webpack_public_path__ + "static/Fall1-cae9fb46241b3fb60db3766e206e3823.mp3";